<template>
  <div class="car-container">
    <dl>
      <dt class="title-wrapper">{{ displayName }}</dt>
      <dd class="image-wrapper">
        <img :src="imageUrl" :alt="displayName" class="car-image" />
      </dd>
      <dd class="config-type">
        <h4>{{ komNumber }}</h4>
      </dd>
      <dd class="full-match-container">
        <div :class="{ 'full-match': isFullMatch }">100% match</div>
      </dd>
      <dd :class="matchingItems.includes('price') ? 'match' : 'mismatch'" class="price">
        {{ i18n.n(price, 'currency') }}
      </dd>
      <dd
        :class="matchingItems.includes('engine') ? 'match' : 'mismatch'"
        class="engine spec-group"
      >
        {{ engine }}
      </dd>
      <dd :class="matchingItems.includes('transmission') ? 'match' : 'mismatch'">
        {{ transmission }}
      </dd>
      <dd :class="matchingItems.includes('colorCode') ? 'match' : 'mismatch'">
        {{ colorCode }}
      </dd>
      <dd :class="matchingItems.includes('interiorCode') ? 'match' : 'mismatch'">
        {{ interiorCode }}
      </dd>
      <dd v-if="options.length" class="spec-group">&nbsp;</dd>
      <dd
        v-for="option in options"
        :key="option.shortId"
        class="spec-group"
        :class="{
          option: option.shortId.substring(0, 7) !== 'missing',
          match: matchingItems.includes(`option-${option.shortId}`),
          additional:
            option.type === stockMatchOptionType.additional ||
            option.type === stockMatchOptionType.aditional,
        }"
      >
        <span>{{
          option.shortId.substring(0, 7) === 'missing' ? '-' : `${option.shortId} - ${option.name}`
        }}</span>
      </dd>
    </dl>
    <div>
      <h5>{{ i18n.t('/stockmatch/statuslabel') }} {{ carStatus }}</h5>
      <app-button data-qa="new-quote-button" @click="$emit('select-car')">
        {{ i18n.t('/stockmatch/newquotebutton') }}
      </app-button>
      <app-button data-qa="stockcar-detail-button" @click="$emit('stockcar-details')">
        {{ i18n.t('/stockmatch/stockcardetailbutton') }}
      </app-button>
      <app-button data-qa="reservation-status-button" @click="$emit('reservation-status')">
        {{ i18n.t('/stockmatch/reservationstatusbutton') }}
      </app-button>
    </div>
  </div>
</template>

<script>
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import stockMatchOptionType from '@/helpers/enums/stockMatchOptionType'
export default {
  components: {
    AppButton,
  },
  props: {
    imageUrl: {
      type: String,
      // default is a 3:2 grey area
      default:
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAACCAQAAAA3fa6RAAAAEElEQVR42mM8858BCBghFAAgNgOZPTV32QAAAABJRU5ErkJggg==',
    },
    displayName: {
      type: String,
      required: true,
    },
    price: {
      type: Number,
      required: true,
    },
    engine: {
      type: String,
      default: '',
    },
    transmission: {
      type: String,
      default: '',
    },
    colorCode: {
      type: String,
      default: '',
    },
    interiorCode: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    isFullMatch: {
      type: Boolean,
      default: false,
    },
    matchingItems: {
      type: Array,
      default: () => [],
    },
    carStatus: {
      type: String,
      default: '',
    },
    komNumber: {
      type: String,
      default: '',
    },
  },
  emits: ['select-car', 'stockcar-details', 'reservation-status'],
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      stockMatchOptionType: stockMatchOptionType,
    }
  },
}
</script>

<style lang="scss" scoped>
.full-match-container div.full-match {
  display: block;
  color: $white;
  background: $color-success;
  padding: 0px 3px;
  border-radius: 3px;
}
.car-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.car-container > *:not(dl) {
  margin-left: 1rem;
}
dl > * {
  padding-left: 1rem;
}
dd {
  &.match {
    position: relative;

    &:before {
      content: '✓';
      position: absolute;
      color: $white;
      font-size: 0.85em;
      line-height: 1.3em;
      background: $color-success;
      padding: 0px 3px;
      border-radius: 3px;
      transform: translate3d(-1.25em, 0.2em, 0);
    }
  }
  &.additional {
    background: $color-primary-light;
  }
}

h5 {
  font-size: 1em;
  line-height: normal;
}
h4 {
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: $font-weight-bold;
  color: $gray-darker;
  margin: 0.25rem 0;
}
button {
  margin-bottom: 1rem;
}
</style>
